/** Strips non-digit chars, returns comma-formatted string. Returns '' for empty input. */
export const formatCurrency = (amount?: number | string | null) => {
  if (!amount && amount !== 0) return '';

  let str = String(amount).replace(/[^\d.]/g, '');

  // Remove extra decimal points (keep only the first)
  const parts = str.split('.');
  if (parts.length > 2) {
    str = parts[0] + '.' + parts.slice(1).join('');
  }

  const [intPart, decPart] = str.split('.');

  // Add thousand separators to the integer part
  const formattedInt = intPart ? Number(intPart).toLocaleString('en-US') : '';

  // Preserve the decimal part exactly as the user typed it
  if (str.includes('.')) {
    return `${formattedInt}.${decPart ?? ''}`;
  }

  return formattedInt;
};

/** Formats currency with exactly 2 decimal places. Use on blur and pre-population. */
export const formatCurrencyOnBlur = (amount?: number | string | null) => {
  if (!amount && amount !== 0) return '';

  const parsed = parseCurrency(String(amount));
  if (parsed === 0 && String(amount).replace(/[^\d.]/g, '') === '') return '';

  const [intPart, decPart = ''] = parsed.toFixed(2).split('.');
  const formattedInt = Number(intPart).toLocaleString('en-US');
  return `${formattedInt}.${decPart}`;
};

/** Parses a comma-formatted currency string back to a number. Returns 0 for invalid input. */
export const parseCurrency = (formatted?: string | null) => {
  if (!formatted) return 0;
  const value = Number(formatted.replace(/[^\d.]/g, ''));
  return Number.isNaN(value) ? 0 : value;
};
